import { render } from "./UseCase.vue?vue&type=template&id=408d64ce"
import script from "./UseCase.vue?vue&type=script&lang=js"
export * from "./UseCase.vue?vue&type=script&lang=js"

import "./UseCase.vue?vue&type=style&index=0&id=408d64ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__